export const FETCH_WORKSPACES = "FETCH_WORKSPACES";
export const ADD_WORKSPACE = "ADD_WORKSPACE";
